import React from "react";
import {StyledFormsHeader} from "./header.style";

const FormContainerHeader = ({children, ...props}) => {
  return <StyledFormsHeader {...props}>{children}</StyledFormsHeader>;
};

export default FormContainerHeader;
